<template>
    <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        :class="positionClasses"
        class="fixed inset-x-0 z-99999 flex items-center gap-x-3 bg-theme-button-bg px-6 py-3 text-theme-text shadow-lg sm:gap-x-6 sm:py-4 sm:before:flex-1 sm:before:content-['']"
    >
        <div
            class="flex w-full min-w-0 items-center gap-x-3 pr-5 sm:w-auto sm:flex-wrap sm:justify-center sm:gap-x-4 sm:gap-y-2 sm:pr-0"
        >
            <p class="m-0 min-w-0 flex-1 text-xs font-medium sm:flex-none sm:text-sm">
                <strong v-if="lead" class="mr-1 text-sm font-bold sm:text-base">{{ lead }}</strong
                >{{ text }}
            </p>
            <BaseButton v-if="ctaLabel" variant="cta" class="shrink-0" :dusk="ctaDusk" @click="$emit('cta')">
                {{ ctaLabel }}
            </BaseButton>
            <BaseButton
                v-if="secondaryLabel"
                variant="ghost"
                class="shrink-0"
                :dusk="secondaryDusk"
                @click="$emit('secondary')"
            >
                {{ secondaryLabel }}
            </BaseButton>
        </div>
        <div class="absolute right-2 top-1 sm:static sm:flex sm:flex-1 sm:justify-end">
            <PillIconButton
                v-if="dismissible"
                icon="close"
                variant="muted"
                :icon-size="14"
                :aria-label="localizations[lang].tooltips.close"
                @click="$emit('dismiss')"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import PillIconButton from '_shared_/UI/Components/PillIconButton.vue';
import BaseButton from '_shared_/UI/Components/buttons/BaseButton.vue';

export default {
    name: 'ComponentBanner',
    components: { PillIconButton, BaseButton },
    props: {
        position: {
            type: String,
            default: 'footer',
            validator: value => ['top', 'footer'].includes(value),
        },
        text: {
            type: String,
            required: true,
        },
        lead: {
            type: String,
            default: null,
        },
        ctaLabel: {
            type: String,
            default: null,
        },
        ctaDusk: {
            type: String,
            default: null,
        },
        /** A second answer beside the call to action, for a banner that wants one either way. */
        secondaryLabel: {
            type: String,
            default: null,
        },
        secondaryDusk: {
            type: String,
            default: null,
        },
        dismissible: {
            type: Boolean,
            default: true,
        },
        autoDismissMs: {
            type: Number,
            default: null,
        },
    },
    emits: ['cta', 'secondary', 'dismiss'],
    data() {
        return {
            dismissTimer: null,
        };
    },
    computed: {
        ...mapState(['localizations', 'lang']),
        /**
         * Edge placement of the full-width banner bar: pinned to the top edge (top) or the bottom edge (footer),
         * with a divider border on the side facing the content.
         * @returns {string} Tailwind position + border classes
         */
        positionClasses() {
            return this.position === 'top'
                ? 'top-0 border-b border-theme-border'
                : 'bottom-0 border-t border-theme-border';
        },
    },
    mounted() {
        if (this.autoDismissMs) {
            this.dismissTimer = setTimeout(() => this.$emit('dismiss'), this.autoDismissMs);
        }
    },
    beforeDestroy() {
        clearTimeout(this.dismissTimer);
    },
};
</script>
